import React, { Component } from 'react';

const SummaryReports = () => {
	return ( <h1>Summary Reports</h1> );
}
 
export default SummaryReports;